<template>
  <div class="animated fadeIn step-container">
      <div class="component-wrapper" v-if="clinicReady">
        <component :is="$route.params.page" 
                  :clinic.sync="clinic" 
                  @finishStep="finishStep" 
                  @cancelChange="cancelChange">
          <div slot='loader' v-show='loading' class='btn btn-sm'><sync-loader size='10px'></sync-loader></div>
        </component>

      </div>
      <sweet-modal icon="success" ref="modal"> </sweet-modal>
  </div>
</template>

<script>
import BasicInfo from '@/pages/clinic/steps/General'
import AddressInfo from '@/pages/clinic/steps/Address'
import ScheduleInfo from '@/pages/clinic/steps/Schedules'
import ServiceInfo from '@/pages/clinic/steps/Services'
import DoctorInfo from '@/pages/clinic/steps/Doctors'
import { SweetModal } from 'sweet-modal-vue'
import SyncLoader from 'vue-spinner/src/SyncLoader'

export default {
  components: {
    SweetModal,
    SyncLoader,
    'general': BasicInfo,
    'clinic_address': AddressInfo,
    'schedules': ScheduleInfo,
    'services': ServiceInfo,
    'doctors': DoctorInfo
  },
  data () {
    return {
      loading: false,
      clinic: {
        en: {
          video_links: []
        },
        th: {
          video_links: []
        },
        images: [],
        schedules: []
      },
      clinicReady: false,
      page: 'general'
    }
  },
  methods: {
    cancelChange () {
    },
    finishStep (clinicDataChanged) {
      if (clinicDataChanged) {
        this.loading = true
        this.$http.put(this.$APP_CONFIG.api.admin.clinicme(this.$route, this.$guser),
          // data
          clinicDataChanged,
          // options
          {
            headers: { 'content-type': 'application/json' }
          }).then(res => {
            this.loading = false
            if (res.body.status === 'success') {
              this.clinic = Object.assign({}, self.clinic, res.body.data)

              if (!this.clinic.th.video_links) {
                this.clinic.th.video_links = []
              }
              if (!this.clinic.en.video_links) {
                this.clinic.en.video_links = []
              }
              this.$refs.modal.open()
            }
          })
      } else {
        this.loading = false
        this.$refs.modal.open()
      }
    }
  },
  created () {
    this.$http.get(this.$APP_CONFIG.api.admin.clinicme(this.$route, this.$guser), { credentials: true }).then(res => {
      this.clinic = Object.assign({}, self.clinic, res.body.data)

      if (!this.clinic.th.video_links) {
        this.clinic.th.video_links = []
      }
      if (!this.clinic.en.video_links) {
        this.clinic.en.video_links = []
      }
      this.clinicReady = true
    }, errorResponse => {
      console.error(errorResponse)
    })
  }
}
</script>

<style lang="sass">
@import "../../../assets/base_container";
</style>



// WEBPACK FOOTER //
// SingleForm.vue?43dfd94a